export const styleMsgDiv_MSGOUT = {
  visibility: "hidden",
};

export const styleMsgDiv_MSGOIN = {
  visibility: "visible",
  width: "90%",
  gridRow: "2/3",
  placeSelf: "end center",
  color: "#0a4ed5",
};
